import { get } from 'lodash';
import { errorLevel } from 'constants/errors';
import { treatErrorAs } from 'api/errors';
import { overlayLayerToFieldViewPlusMapType, FIELD_VIEW_PLUS_URL } from 'constants/imagery';

export const updateLegend = ({username, fieldUuid, crop, mapType, maxValue, minValue, steps, metric}) => {
  const fvPlusMapType = get(overlayLayerToFieldViewPlusMapType, mapType, mapType);
  const body = JSON.stringify({
    cloudUUID: fieldUuid,
    crop,
    mapType: fvPlusMapType,
    maxValue,
    minValue,
    steps,
    metric,
    username
  });
  return fetch(`${FIELD_VIEW_PLUS_URL}/legend`, {
    method: 'put',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body
  })
  .catch(treatErrorAs({ severity: errorLevel.INFO }));
};
